module.exports = __webpack_public_path__ + "img/京大戟.6015ab7f.jpg";